/**
 * @generated SignedSource<<68bd5ebb2723c73c7dfc32c7bd598383>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_issueFieldTeamReadviewFull_TeamReadView$data = {
  readonly selectedTeam: {
    readonly fullTeam: {
      readonly avatarUrl: string | null | undefined;
    } | null | undefined;
    readonly jiraSuppliedId: string;
    readonly jiraSuppliedName: string | null | undefined;
    readonly jiraSuppliedTeamId: string;
  } | null | undefined;
  readonly " $fragmentType": "team_issueFieldTeamReadviewFull_TeamReadView";
};
export type team_issueFieldTeamReadviewFull_TeamReadView$key = {
  readonly " $data"?: team_issueFieldTeamReadviewFull_TeamReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamReadviewFull_TeamReadView">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "team_issueFieldTeamReadviewFull_TeamReadView",
  "selections": [
    {
      "concreteType": "JiraTeamView",
      "kind": "LinkedField",
      "name": "selectedTeam",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedId"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedName"
        },
        {
          "kind": "ScalarField",
          "name": "jiraSuppliedTeamId"
        },
        {
          "args": [
            {
              "kind": "Literal",
              "name": "siteId",
              "value": "None"
            }
          ],
          "concreteType": "TeamV2",
          "kind": "LinkedField",
          "name": "fullTeam",
          "plural": false,
          "selections": [
            {
              "alias": "avatarUrl",
              "kind": "ScalarField",
              "name": "smallAvatarImageUrl"
            }
          ],
          "storageKey": "fullTeam(siteId:\"None\")"
        }
      ]
    }
  ],
  "type": "JiraTeamViewField"
};

(node as any).hash = "5e025acdbc7e2800bb2d4d447b5328a3";

export default node;
